import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { FiiConcept } from 'src/app/shared/models/FiiConcept';
import { FiiConceptLang } from 'src/app/shared/models/FiiConceptLang';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';

@Component({
  selector: 'app-fiiconcepts-dtl',
  templateUrl: './fiiconcepts-dtl.component.html',
  styleUrls: ['./fiiconcepts-dtl.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class FiiconceptsDtlComponent implements OnInit {

  /** SECURITY */
  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;

  /** LABELS */
  lbl_go_Back: string = "back_";
  lbl_church_name: string = "church_name_";
  lbl_workshop: string = "workshop_";
  lbl_schedule: string = "schedule_";
  lbl_participants: string = "participants_";
  lbl_new_record: string = "new_record_";
  lbl_name: string = "name_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_email: string = "email_";
  lbl_gender: string = "gender_";
  lbl_edit: string = "edit_";
  lbl_delete: string = "delete_";
  lbl_search: string = "search_";
  lbl_particp15s: string = "10a15a_particip_";
  lbl_participants_12: string = "participants_";
  lbl_participants_1st: string = "participants_2nd_sesion_";
  lbl_future_guide: string = "future_guide_";
  lbl_partic_partner: string = "partic_partners_";
  lbl_no_sent: string = "no_sent_";
  lbl_age: string = "age_";
  lbl_school_prep_guides: string = "school_prep_guides_";
  lbl_comments: string = "comments_";
  lbl_date: string = "date_";
  lbl_save: string = "save_";
  lbl_guide_id: string = "guide_id_";
  lbl_certificate: string = "certificate_";
  lbl_change_Status_Guide_or_Comment: string = "change_Status_Guide_or_Comment";
  lbl_coordination: string = "coordination_";
  lbl_guideId: string = "guideId_";
  lbl_status: string = "status_";
  lbl_leaving_reason: string = "leaving_reason_";
  lbl_select: string = "select_";
  lbl_send: string = "send_";
  lbl_guide: string = "guide_";
  lbl_confirm: string = "confirm_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_updated_data: string = "updated_data_";
  lstCols: { field: string; header: any; }[];


  /** COMPONENT */
  dataParent: any;

  /** EDIT/CREAT FORM */
  fakeAutData: any[];
  fakeVisData: any[];
  autList: any[];
  visList: any[];

  fiiConceptsTemp: FiiConcept = {
    "concepId": "",
    "conType": "",
    "descrip": null,
    "intAut": "0",
    "intVis": "0",
    "localAut": "0",
    "localVis": "0",
    "natAut": "0",
    "natVis": "0",
    "orderLn": "",
    "shrDesc": null,
    "zonAut": "0",
    "zonVis": "0",
    "visList": [
    ],
    "autList": [],
    "descripTmp": null,
    "shrDescTmp": null,
  };
  submitted: boolean = false;
  opt: string = '';

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** END POINTS FII CONCEPT*/
  endPointCreateFiiconceptById = "createFiiconcept";
  endPointUpdateFiiconceptById = "updateFiiconcept";
  endPointLanguageByStoreId = "getListSpkLangByStoreId";

  /** END POINTS FII CONCEPT LANGUAGE*/
  endPointGetFiiConceptLanguage = "getFiiconceptlangId";
  endPointCreateFiiConceptLanguage = "createFiiconceptlang";
  endPointUpdateFiiConceptLanguage = "updateFiiconceptlang";
  endPointDeleteFiiConceptLanguage = "deleteFiiconceptlang";

  /** LANGUAGE ADD */
  langForm: FormGroup;
  languagesLst: FiiConceptLang[];
  languagesLstGlobal: ValuesVO[];
  langFormChange: FormGroup;

  /**
   * This is a constructor function that initializes various services and variables used in the
   * component, and also handles authentication based on the token and device parameters passed in the
   * URL.
   * @param {MessageService} messageService - The `messageService` parameter is an instance of the
   * `MessageService` class, which is used for displaying messages to the user.
   * @param {ApiService} apiService - The `apiService` parameter is an instance of the `ApiService`
   * class. It is used to make API calls and interact with the backend server.
   * @param {Router} router - The `router` parameter is used for navigating between different routes in
   * your application. It provides methods like `navigate` to programmatically navigate to a different
   * route.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class.
   * It is used to access information about the currently activated route, such as route parameters,
   * query parameters, and data resolved from route resolvers. It provides methods and properties to
   * subscribe to changes in the route and retrieve the current
   * @param {AuthenticationService} authenticationService - The `authenticationService` parameter is a
   * service that handles user authentication and authorization. It is used to get the current user
   * value.
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
   * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
   * related to the Tovpil entity or data. It likely provides methods for fetching, creating
   * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
   * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
   */
  constructor(private messageService: MessageService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,) {

    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;

    this.langForm = this.fb.group({
      data_language: [null],
      data_desc: [''],
      data_shr: [''],
    });

    this.langFormChange = this.fb.group({
      data_language_change: [null],
    });


    this.fakeAutData = [
      { label: 'INT AUT', value: 'intAut' },
      { label: 'ZONE AUT', value: 'zonAut' },
      { label: 'NATIONAL AUT', value: 'natAut' },
      { label: 'LOCAL AUT', value: 'localAut' }
    ];
    this.fakeVisData = [
      { label: 'INT VIS', value: 'intVis' },
      { label: 'ZONE VIS', value: 'zonVis' },
      { label: 'NATIONAL VIS', value: 'natVis' },
      { label: 'LOCAL VIS', value: 'localVis' }
    ];

    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
      });

    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
    }
  }

  /**
   * The ngOnInit function checks if there is a dataParent object, and if so, assigns its security and
   * opt properties to the component's security and opt variables respectively. If there is no dataParent
   * object, it assigns the currentUserValue from the authenticationService to the currentUser variable
   * and calls the goBack function. Finally, it calls the getSecurity function.
   */
  ngOnInit(): void {
    if (this.dataParent) {
      this.security = this!.dataParent!.security ? this.dataParent.security : null;
      this.opt = this!.dataParent!.opt ? this.dataParent.opt : null;
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
      this.goBack();
    }
    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and then performs additional actions based on the response.
   * @param {string} user - The user parameter is a string that represents the username or email of the
   * user trying to authenticate.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
          }
        },
        error => {
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and then calls another function to get
   * translated labels.
   */
  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;
          this.getTranslatedLabels();
        });
    } else {
      this.getTranslatedLabels();
    }
  }

  /**
   * The `loadData` function checks the value of `opt` and `dataSecurity` parameters and performs
   * different actions based on their values, and then sets the `blocked` property to `true` for 1.5
   * seconds before setting it back to `false`.
   * @param {any} dataSecurity - The dataSecurity parameter is of type "any", which means it can accept
   * any data type. It is used to pass some data related to security.
   * @param {any} opt - The "opt" parameter is a string that represents the operation type. It can have
   * two possible values: 'C' for creating a new data entry and 'U' for updating an existing data entry.
   */
  loadData(dataSecurity: any, opt: any) {
    this.blocked = true;

    if (opt == 'C' && dataSecurity != null) {
      //console.debug("Se creará uno nuevo");

    } else if (opt == 'U' && dataSecurity != null) {

      const fiiConceptsTemp = this.convertPropertiesToJsonFormat([this.dataParent.data])[0];
      this.fiiConceptsTemp = { ...fiiConceptsTemp };
      this.fiiConceptsTemp.descripTmp = this.fiiConceptsTemp.descrip;
      this.fiiConceptsTemp.shrDescTmp = this.fiiConceptsTemp.shrDesc;
      //console.debug("Se actualizara", this.fiiConceptsTemp);

    } else {
      this.goBack();
    }
    setTimeout(() => {
      this.blocked = false;
      this.getLanguages();
    }, 1500);
  }

  /**
   * The goBack function closes the current window.
   */
  goBack() {
    let obj = {
      security: this.security
    }
    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }
    this.router.navigate(['catalogs/fIIConcepts'], navigationExtras);
  }

  /**
   * The function `getTranslatedLabels()` retrieves translated labels from an API and assigns them to
   * corresponding variables.
   */
  getTranslatedLabels() {
    let map = new Map();
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_church_name, this.lbl_schedule, this.lbl_participants, this.lbl_new_record, this.lbl_name, this.lbl_cell_phone, this.lbl_email, this.lbl_gender, this.lbl_edit, this.lbl_delete, this.lbl_search, this.lbl_particp15s, this.lbl_participants_12, this.lbl_participants_1st, this.lbl_future_guide, this.lbl_partic_partner, this.lbl_no_sent, this.lbl_age, this.lbl_workshop, this.lbl_school_prep_guides, this.lbl_comments, this.lbl_date, this.lbl_save, this.lbl_guide_id, this.lbl_certificate, this.lbl_change_Status_Guide_or_Comment, this.lbl_coordination, this.lbl_guideId, this.lbl_status, this.lbl_leaving_reason, this.lbl_select, this.lbl_send, this.lbl_guide, this.lbl_confirm, this.lbl_are_you_sure, this.lbl_updated_data]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_church_name = map.get(this.lbl_church_name);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_gender = map.get(this.lbl_gender);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_particp15s = map.get(this.lbl_particp15s);
        this.lbl_participants_12 = map.get(this.lbl_participants_12);
        this.lbl_participants_1st = map.get(this.lbl_participants_1st);
        this.lbl_future_guide = map.get(this.lbl_future_guide);
        this.lbl_partic_partner = map.get(this.lbl_partic_partner);
        this.lbl_no_sent = map.get(this.lbl_no_sent);
        this.lbl_age = map.get(this.lbl_age);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_school_prep_guides = map.get(this.lbl_school_prep_guides);
        this.lbl_comments = map.get(this.lbl_comments);
        this.lbl_date = map.get(this.lbl_date);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_certificate = map.get(this.lbl_certificate);
        this.lbl_guide_id = map.get(this.lbl_guide_id);
        this.lbl_change_Status_Guide_or_Comment = map.get(this.lbl_change_Status_Guide_or_Comment);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_guideId = map.get(this.lbl_guideId);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_leaving_reason = map.get(this.lbl_leaving_reason);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_send = map.get(this.lbl_send);
        this.lbl_guide = map.get(this.lbl_guide);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_updated_data = map.get(this.lbl_updated_data);
      });
    this.getVisList();
    this.getAutList();

    this.loadData(this.security, this.opt);
  }

  /**
   * The function "getVisList" assigns the value of "fakeVisData" to the variable "visList".
   */
  getVisList() {
    this.visList = this.fakeVisData;
  }

  /**
   * The function "getAutList" assigns the value of "fakeAutData" to the variable "autList".
   */
  getAutList() {
    this.autList = this.fakeAutData;
  }

  /**
   * The function `saveFiiConcepts()` is used to save Fii concepts by either updating or creating them,
   * and then resetting the necessary variables.
   */
  saveFiiConcepts() {
    this.submitted = true;
    this.fiiConceptsTemp = this.convertJsonFormatToProperties(this.fiiConceptsTemp);

    if (this.fiiConceptsTemp) {
      if (this.opt == 'U') {
        // UPDATE 
        this.confirmationService.confirm({
          message: '¿Esta seguro de actualizar el concepto fii ' + (this!.fiiConceptsTemp!.descrip ? this!.fiiConceptsTemp!.descrip : 'n/a') + '?',
          header: 'Confirmación',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Actualizar",
          rejectLabel: "Cancelar",
          accept: () => {
            this.updateFiiConcepts(this.fiiConceptsTemp);
          },
          reject: () => {
            this.messageService.add({ severity: 'warn', summary: 'Concepto FII', detail: 'Se canceló actualización' });
          }
        });
      }
      else {
        // CREATE 
        this.confirmationService.confirm({
          message: '¿Esta seguro de guardar el concepto fii ' + (this!.fiiConceptsTemp!.descrip ? this!.fiiConceptsTemp!.descrip : 'n/a') + '?',
          header: 'Confirmación',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Guardar",
          rejectLabel: "Cancelar",
          accept: () => {
            this.createOneFiiConcepts(this.fiiConceptsTemp);
          },
          reject: () => {
            this.messageService.add({ severity: 'warn', summary: 'Concepto FII', detail: 'Se canceló creación' });
          }
        });
      }
    }
    this.submitted = false;
  }

  /**
   * The function "resetFiiConcept" resets the "fiiConceptsTemp" variable to an empty object.
   */
  resetFiiConcept() {
    this.fiiConceptsTemp = null;
    this.fiiConceptsTemp = {};
  }

  /**
   * The function `updateFiiConcepts` updates a FiiConcept object and displays a success message if the
   * update is successful.
   * @param {FiiConcept} fiiConceptsTemp - The parameter `fiiConceptsTemp` is an object of type
   * `FiiConcept` which contains the following properties:
   */
  updateFiiConcepts(fiiConceptsTemp: FiiConcept) {
    //console.debug("Se editará: ", fiiConceptsTemp);
    this.blocked = true;
    this.tovpilCrudService.fetch(this.endPointUpdateFiiconceptById, {
      "concepId": fiiConceptsTemp!.concepId ? fiiConceptsTemp!.concepId.trim() : null,
      "conType": fiiConceptsTemp!.conType ? fiiConceptsTemp!.conType.trim() : null,
      "descrip": fiiConceptsTemp!.descrip ? fiiConceptsTemp!.descrip.trim() : null,
      "intAut": fiiConceptsTemp!.intAut.trim(),
      "intVis": fiiConceptsTemp!.intVis.trim(),
      "localAut": fiiConceptsTemp!.localAut.trim(),
      "localVis": fiiConceptsTemp!.localVis.trim(),
      "natAut": fiiConceptsTemp!.natAut.trim(),
      "natVis": fiiConceptsTemp!.natVis.trim(),
      "orderLn": fiiConceptsTemp!.orderLn ? fiiConceptsTemp!.orderLn.trim() : "0",
      "shrDesc": fiiConceptsTemp!.shrDesc ? fiiConceptsTemp!.shrDesc.trim() : null,
      "zonAut": fiiConceptsTemp!.zonAut.trim(),
      "zonVis": fiiConceptsTemp!.zonVis.trim(),
    }).then(result => {
      if (result.success) {
        this.messageService.add({ severity: 'success', summary: 'Concepto FII', detail: 'Se actualizó correctamente' });
      } else {
        console.error("An error occurred while fetching purchase order data:");
        this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
        this.messageService.add({ severity: 'warn', summary: 'Concepto FII', detail: 'Se canceló actualización, intentelo mas tarde' });
      }
    }).finally(() => {
      setTimeout(() => {
        this.blocked = false;
        this.goBack();
        this.resetFiiConcept();
      }, 1500);
    });
  }

  /**
   * The function `createOneFiiConcepts` creates a new FiiConcept object and sends a request to the
   * server to save the data, displaying success or error messages accordingly.
   * @param {FiiConcept} fiiConceptsTemp - The parameter `fiiConceptsTemp` is an object of type
   * `FiiConcept` which contains the following properties:
   */
  createOneFiiConcepts(fiiConceptsTemp: FiiConcept) {
    //console.debug("Se creará: ", fiiConceptsTemp);
    this.blocked = true;
    this.tovpilCrudService.fetch(this.endPointCreateFiiconceptById, {
      "concepId": fiiConceptsTemp!.concepId ? fiiConceptsTemp!.concepId.trim().toUpperCase() : null,
      "conType": fiiConceptsTemp!.conType ? fiiConceptsTemp!.conType.trim().toUpperCase() : null,
      "descrip": fiiConceptsTemp!.descrip ? fiiConceptsTemp!.descrip.trim() : null,
      "intAut": fiiConceptsTemp!.intAut.trim(),
      "intVis": fiiConceptsTemp!.intVis.trim(),
      "localAut": fiiConceptsTemp!.localAut.trim(),
      "localVis": fiiConceptsTemp!.localVis.trim(),
      "natAut": fiiConceptsTemp!.natAut.trim(),
      "natVis": fiiConceptsTemp!.natVis.trim(),
      "orderLn": fiiConceptsTemp!.orderLn ? fiiConceptsTemp!.orderLn.trim() : "0",
      "shrDesc": fiiConceptsTemp!.shrDesc ? fiiConceptsTemp!.shrDesc.trim() : null,
      "zonAut": fiiConceptsTemp!.zonAut.trim(),
      "zonVis": fiiConceptsTemp!.zonVis.trim(),
    }).then(result => {
      if (result.success) {
        this.messageService.add({ severity: 'success', summary: 'Concepto FII', detail: 'Se guardó correctamente' });
      } else {
        console.error("An error occurred while fetching purchase order data:");
        this.messageService.add({ severity: 'warn', summary: 'Concepto FII', detail: 'Se canceló guardado, intentelo mas tarde' });
        this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
      }
    }).finally(() => {
      setTimeout(() => {
        this.blocked = false;
        this.goBack();
        this.resetFiiConcept();
      }, 1500);
    });
  }

  /**
   * The function converts properties of FiiConcept objects into JSON format by mapping specific values
   * to labels.
   * @param {FiiConcept[]} fiiConceptList - An array of FiiConcept objects.
   * @returns The function returns the `fiiConceptList` array after
   * modifying its elements by adding `visList` and `autList` properties.
   */
  convertPropertiesToJsonFormat(fiiConceptList: FiiConcept[]) {
    const autMappings = {
      intAut: { label: 'INT AUT', value: 'intAut' },
      zonAut: { label: 'ZONE AUT', value: 'zonAut' },
      natAut: { label: 'NATIONAL AUT', value: 'natAut' },
      localAut: { label: 'LOCAL AUT', value: 'localAut' }
    };

    const visMappings = {
      intVis: { label: 'INT VIS', value: 'intVis' },
      zonVis: { label: 'ZONE VIS', value: 'zonVis' },
      natVis: { label: 'NATIONAL VIS', value: 'natVis' },
      localVis: { label: 'LOCAL VIS', value: 'localVis' }
    };

    fiiConceptList.forEach(fiiConcept => {
      fiiConcept.visList = [];
      fiiConcept.autList = [];

      for (const [key, mapping] of Object.entries(autMappings)) {
        if (Boolean(fiiConcept[key]) === true) {
          fiiConcept.autList.push(mapping);
        }
      }

      for (const [key, mapping] of Object.entries(visMappings)) {
        if (Boolean(fiiConcept[key]) === true) {
          fiiConcept.visList.push(mapping);
        }
      }
    });

    return fiiConceptList;
  }

  /**
   * The function converts a JSON object format to a properties format by mapping specific keys and
   * values.
   * @param {FiiConcept} fiiConcept - The `fiiConcept` parameter is an object that represents a concept
   * in a specific format. It contains properties such as `intAut`, `zonAut`, `natAut`, `localAut`,
   * `intVis`, `zonVis`, `natVis`, `localVis`, `visList`,
   * @returns the updated `fiiConcept` object.
   */
  convertJsonFormatToProperties(fiiConcept: FiiConcept) {
    const autMappings = {
      INTAUT: 'intAut',
      ZONAUT: 'zonAut',
      NATAUT: 'natAut',
      LOCALAUT: 'localAut'
    };

    const visMappings = {
      INTVIS: 'intVis',
      ZONVIS: 'zonVis',
      NATVIS: 'natVis',
      LOCALVIS: 'localVis'
    };

    const propertiesToReset = ['intAut', 'zonAut', 'natAut', 'localAut', 'intVis', 'zonVis', 'natVis', 'localVis'];

    for (const property of propertiesToReset) {
      fiiConcept[property] = '0';
    }

    const allVersions = [...fiiConcept.visList, ...fiiConcept.autList];

    for (const version of allVersions) {
      const label = version['value'].toUpperCase();

      if (autMappings.hasOwnProperty(label)) {
        fiiConcept[autMappings[label]] = '1';
      } else if (visMappings.hasOwnProperty(label)) {
        fiiConcept[visMappings[label]] = '1';
      }
    }

    return fiiConcept;
  }

  /**
   * The handleError function logs an error message to the console and adds an error message to the
   * message service.
   * @param {string} message - The `message` parameter is a string that represents the error message that
   * occurred while parsing.
   */
  handleError(message: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  }

  /**
   * The function "getLanguages" initializes an array of language objects with their corresponding labels
   * and values.
   */
  getLanguages() {
    //console.debug("Lenguajes: ", this.fiiConceptsTemp);
    this.getGlobalLanguajes();
    this.tovpilCrudService.fetch(this.endPointGetFiiConceptLanguage, {
      "id": {
        "concepId": this.fiiConceptsTemp!.concepId.length > 1 ? this.fiiConceptsTemp!.concepId : null
      }
    }).then(result => {
      if (!result.success) {
        console.error("An error occurred while fetching language  data:");
        this.messageService.add({ severity: 'warn', summary: 'Concepto FII Lenguaje', detail: 'No se pudieron obtener los datos, intentelo mas tarde' });
      } else {
        this.languagesLst = result.data;
        this.messageService.add({ severity: 'success', summary: 'Concepto FII Lenguaje', detail: 'Se obtuvieron correctamente los datos' });
      }
    }).catch(error => {
      console.error(error);
      this.messageService.add({ severity: 'warn', summary: 'Concepto FII Lenguaje', detail: 'No se pudieron obtener los datos, intentelo mas tarde' });
    });
  }


  /**
 * The function "getLanguages" initializes an array of language objects with their labels and values.
 */
  getGlobalLanguajes() {
    //console.debug(this.security)
    this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, {
      "language": this.security!.language || null,
      "storeId": this.security!.storeId || null
    }).then(result => {
      if (result.success) {
        //console.debug("Lenguajes: ", result.data);
        this.languagesLstGlobal = result.data;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        this.handleError("Hubo un problema, no hay información que obtener para lenguajes. Por favor, recargue la página e inténtelo nuevamente más tarde.");
      }
    }).catch(error => {
      console.error("An error occurred while fetching purchase order data:");
      this.handleError("Hubo un problema, no hay información que obtener para lenguajes. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    });
  }

  /**
   * The function `updateFiiLanguage()` updates the Fii language based on the user's input and displays a
   * confirmation message before updating.
   */
  updateFiiLanguage() {
    if (this.langFormChange.valid) {
      let param = {
        'language': this.langFormChange.get('data_language_change').value,
      }
      //console.debug(param)
      this.confirmationService.confirm({
        message: '¿Esta seguro de actualizar al lenguaje fii ' + (param!.language!.id!.language ? param!.language!.id!.language : 'n/a') + '?',
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Actualizar",
        rejectLabel: "Cancelar",
        accept: () => {
          this.fiiConceptsTemp.descripTmp = param!.language!.descrip;
          this.fiiConceptsTemp.shrDescTmp = param!.language!.shrDesc;
          this.messageService.add({ severity: 'info', summary: 'Lenguaje FII', detail: 'Se actualizó correctamente' });
          setTimeout(() => {
            //console.debug("Traduccion a actualizar : ", param);
          }, 1500);
        },
        reject: () => {
          this.messageService.add({ severity: 'warn', summary: 'Lenguaje FII', detail: 'Se canceló correctamente' });
        }
      });

    } else {
      this.messageService.add({ severity: 'warn', summary: 'Lenguaje FII', detail: 'Datos Invalidos, Por favor ingreese los datos solicitados!' });
    }
  }

  /**
   * The function `saveFiiLanguage()` is used to save a FII language concept, validating the form data
   * and displaying confirmation messages.
   * @returns nothing (undefined).
   */
  saveFiiLanguage() {
    if (!this.langForm.valid) {
      this.messageService.add({ severity: 'warn', summary: 'Concepto Lenguaje FII', detail: 'Datos Inválidos. Por favor, ingrese los datos solicitados.' });
      return;
    }

    const languageValue = (this.langForm.get('data_language').value);
    const param = {
      id: {
        concepId: this.fiiConceptsTemp!.concepId ? this.fiiConceptsTemp!.concepId : null,
        language: languageValue ? languageValue.valueId : 'n/a'
      },
      descrip: this.langForm.get('data_desc').value,
      shrDesc: this.langForm.get('data_shr').value
    };

    //console.debug(param);

    if (!this.validateExistsLanguage(this.languagesLst, param.id.language)) {
      this.confirmationService.confirm({
        message: `¿Está seguro de guardar el lenguaje fii ${param!.id!.language ? param!.id!.language : 'N/A'}?`,
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Guardar',
        rejectLabel: 'Cancelar',
        accept: () => this.saveFiiConceptLanguage(param),
        reject: () => this.messageService.add({ severity: 'warn', summary: 'Concepto Lenguaje FII', detail: 'Se canceló el guardado' })
      });
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Concepto Lenguaje FII', detail: 'Ya existe el concepto fii lenguaje' });
    }
  }

  /**
   * The function `saveFiiConceptLanguage` saves a FII concept language by making a fetch request to an
   * endpoint and displaying success or error messages.
   * @param {any} param - The parameter "param" is of type "any", which means it can accept any data
   * type. It is used as the payload to be sent in the HTTP request to the
   * "endPointCreateFiiConceptLanguage" endpoint.
   */
  saveFiiConceptLanguage(param: any): void {
    this.tovpilCrudService.fetch(this.endPointCreateFiiConceptLanguage, param).then(result => {
      if (result.success) {
        this.messageService.add({ severity: 'success', summary: 'Concepto FII Lenguaje', detail: 'Se guardó correctamente el lenguaje' });
        this.getLanguages();
        this.langForm.reset();
      } else {
        console.error('An error occurred while fetching purchase order data:');
        this.messageService.add({ severity: 'warn', summary: 'Concepto FII Lenguaje', detail: 'No se pudo guardar los datos. Inténtelo más tarde' });
      }
    }).catch(error => {
      console.error(error);
      this.messageService.add({ severity: 'warn', summary: 'Concepto FII Lenguaje', detail: 'No se pudo guardar los datos. Inténtelo más tarde' });
    });
  }

  /**
   * The function checks if a given value exists in an array of language objects.
   * @param languages - An array of objects representing different languages. Each object has a property
   * called "id" which contains another object with a property called "language" representing the
   * language name.
   * @param value - The value parameter is the language value that you want to check if it exists in the
   * languages array.
   * @returns a boolean value.
   */
  validateExistsLanguage(languages, value) {
    return languages.some(objeto => objeto.id?.language === value);
  }

  /**
   * The function "onRowEditInit" takes a parameter "fiiLanguage" and does nothing.
   * @param {any} fiiLanguage - The parameter `fiiLanguage` is of type `any`, which means it can accept
   * any data type.
   */
  onRowEditInit(fiiLanguage: any) {
    //Nothing
  }

  /**
   * The function `onRowEditSave` is used to save the edited language data for a concept in the FII
   * system.
   * @param {any} fiiLanguage - The parameter `fiiLanguage` is of type `any`, which means it can accept
   * any data type. It is used as an argument in the `onRowEditSave` function.
   */
  onRowEditSave(fiiLanguage: any) {
    //console.debug("Editando lenguaje:", fiiLanguage);
    this.tovpilCrudService.fetch(this.endPointUpdateFiiConceptLanguage, fiiLanguage).then(result => {
      if (!result.success) {
        console.error("An error occurred while fetching purchase order data:");
        this.messageService.add({ severity: 'warn', summary: 'Concepto FII Lenguaje', detail: 'No se pudieron actualizar los datos, intentelo mas tarde' });
      } else {
        this.messageService.add({ severity: 'success', summary: 'Concepto FII Lenguaje', detail: 'Se actualizó correctamente el lenguaje' });
        this.getLanguages();
      }
    }).catch(error => {
      console.error(error);
      this.messageService.add({ severity: 'warn', summary: 'Concepto FII Lenguaje', detail: 'No se pudieron actualizar los datos, intentelo mas tarde' });
    });
  }

  /**
   * The function `onRowEditDelete` is used to delete a language from a concept in a FII system and
   * display success or error messages accordingly.
   * @param {any} fiiLanguage - The parameter `fiiLanguage` is of type `any`, which means it can accept
   * any data type. It is used as an argument in the `onRowEditDelete` function.
   */
  onRowEditDelete(fiiLanguage: any) {
    //console.debug("Eliminando lenguaje:", fiiLanguage);
    this.tovpilCrudService.fetch(this.endPointDeleteFiiConceptLanguage, fiiLanguage).then(result => {
      if (!result.success) {
        console.error("An error occurred while fetching purchase order data:");
        this.messageService.add({ severity: 'warn', summary: 'Concepto FII Lenguaje', detail: 'No se pudieron eliminar los datos, intentelo mas tarde' });
      } else {
        this.messageService.add({ severity: 'success', summary: 'Concepto FII Lenguaje', detail: 'Se eliminó correctamente el lenguaje' });
        this.getLanguages();
      }
    }).catch(error => {
      console.error(error);
      this.messageService.add({ severity: 'warn', summary: 'Concepto FII Lenguaje', detail: 'No se pudieron actualizar los datos, intentelo mas tarde' });
    });
  }

  /**
   * The function "onRowEditCancel" takes in a "fiiLanguage" object and an index number, and does
   * nothing.
   * @param {any} fiiLanguage - The parameter `fiiLanguage` is of type `any`, which means it can be any
   * data type. It is used to represent the language object that is being edited or cancelled.
   * @param {number} index - The index parameter is a number that represents the index of the row being
   * edited.
   */
  onRowEditCancel(fiiLanguage: any, index: number) {
    // Nothing
  }
}